
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-converter",
      function () {
        return require("private-next-pages/case-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-converter"])
      });
    }
  